export var FValidationErrorTypeEnum;
(function (FValidationErrorTypeEnum) {
    FValidationErrorTypeEnum["INVALID_FORM_ERROR_MSG"] = "form.invalid.has_error";
    FValidationErrorTypeEnum["UNKNOWN_FORM_ERROR_MSG"] = "unknow_form_error";
    FValidationErrorTypeEnum["KNOWN_STRIPE_ERROR_MSG"] = "stripe_known_error";
    FValidationErrorTypeEnum["UNKNOWN_STRIPE_ERROR_MSG"] = "stripe_unknown_error";
    FValidationErrorTypeEnum["SLOT_IS_FULL_PARTIAL_ERROR_MSG"] = "slot_is_full";
    FValidationErrorTypeEnum["MISSING_CLIENT_SECRET"] = "missing_client_secret";
    FValidationErrorTypeEnum["UNKNOWN_ERROR"] = "unknown_error";
})(FValidationErrorTypeEnum || (FValidationErrorTypeEnum = {}));
